<template>
  <section class="catalog_head_outer">
    <div class="container">
      <div class="page_head">
        <bread-crumbs></bread-crumbs>
        <div class="flx">
          <h2>{{ category_name }}</h2>
          <div class="pagination_head flx">
            <items-per-page :value.sync="perPage" :items="perPageItems"></items-per-page>
            <items-sort-by v-if="isAuth()" :items="itemsSortBy" :sort-by.sync="sortBy" :sort-direction.sync="sortDirection"></items-sort-by>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import BreadCrumbs from '../../BreadCrumbs/BreadCrumbs'
import ItemsPerPage from '../../Pagination/ItemsPerPage'
import ItemsSortBy from '../../Pagination/ItemsSortBy'
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'

export default {
  name: 'CatalogHeadOuter',
  inject: ['isAuth'],
  components: {
    BreadCrumbs,
    ItemsPerPage,
    ItemsSortBy
  },
  computed: {
    ...mapState('catalog', {
      per_page: 'perPage',
      perPageItems: 'perPageItems',
      itemsSortBy: 'itemsSortBy',
      sort_by: 'sortBy',
      sort_direction: 'sortDirection',
      category_name: 'current_category_name'
    }),
    ...mapGetters('catalog', ['getBreadCrumbs']),
    perPage: {
      get () { return parseInt(this.per_page) },
      set (val) {
        this.setPerPage(parseInt(val))
        this.$nextTick(() => {
          this.getProducts()
        })
      }
    },
    sortBy: {
      get () { return this.sort_by },
      set (val) {
        this.setSortBy(val)
        this.$nextTick(() => {
          this.getProducts()
        })
      }
    },
    sortDirection: {
      get () { return this.sort_direction },
      set (val) {
        this.setSortDirection(val)
      }
    }
  },
  methods: {
    ...mapMutations('catalog', ['setSortBy', 'setSortDirection', 'setPerPage']),
    ...mapActions('products', ['getProducts'])
  }
}
</script>

<style scoped>

</style>
